module.exports = __webpack_public_path__ + "media/images/telefono_corona1-cb9100cb7775de0c148485c4bc640c61.jpg";